import React from 'react';
import { Button, DebouncedSearchInput } from '@deephaven/components';
import { vsNewFile, vsNewFolder } from '@deephaven/icons';
import "./FileExplorerToolbar.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FileExplorerToolbar(_ref) {
  var createFile = _ref.createFile,
    createFolder = _ref.createFolder,
    onSearchChange = _ref.onSearchChange,
    _ref$defaultSearchTex = _ref.defaultSearchText,
    defaultSearchText = _ref$defaultSearchTex === void 0 ? '' : _ref$defaultSearchTex;
  return /*#__PURE__*/_jsxs("div", {
    className: "file-explorer-toolbar",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "file-explorer-toolbar-buttons",
      children: [/*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        icon: vsNewFile,
        tooltip: "New notebook",
        onClick: createFile,
        "aria-label": "New notebook"
      }), /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        icon: vsNewFolder,
        tooltip: "New folder",
        onClick: createFolder,
        "aria-label": "New folder"
      })]
    }), onSearchChange && /*#__PURE__*/_jsx("div", {
      className: "file-explorer-toolbar-search",
      children: /*#__PURE__*/_jsx(DebouncedSearchInput, {
        value: defaultSearchText,
        onChange: onSearchChange,
        placeholder: "Search by name"
      })
    })]
  });
}
export default FileExplorerToolbar;
//# sourceMappingURL=FileExplorerToolbar.js.map